import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import Vuex from 'vuex'
import VueSessionStorage from 'vue-sessionstorage'

import App from './App'
import router from './router'
import store from './store'
// import 'vuetify/dist/vuetify.min.css'
import vuetify from './plugins/vuetify'

// Global CSS Styles
import './sass/main.scss'

// if (process.env.NODE_ENV === 'development') {
//   Vue.config.backend_base_url = 'http://localhost:8000'
// } else {
//   Vue.config.productionTip = true
//   Vue.config.backend_base_url = 'http://144.76.39.146:8000'
// }

Vue.config.productionTip = true
Vue.config.backend_base_url = 'https://grahame.qmkey.com'
// Vue.use(BootstrapVue)

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: Vue.config.backend_base_url,
  tokenType: 'Token',
})
Vue.use(Vuex)
Vue.use(VueSessionStorage)

Vue.prototype.$base = Vue.config.backend_base_url

// Global registration
axios.defaults.baseURL = Vue.config.backend_base_url + '/api/v1'

Vue.mixin({
  methods: {
    render_form_errors: function(err) {
      this.message = ''
      this.loading = false
      if (!err.body) {
        if (err.response) {
          if (err.response.data) err.body = err.response.data
          else err.body = err.response
        }
      }
      if (typeof err.body === 'string') this.message += err.body
      else {
        for (var fieldname in err.body) {
          if (err.body.hasOwnProperty(fieldname)) {
            if (fieldname != 'non_field_errors') {
              var fielddesc = fieldname
              var node = document.getElementById('label_' + fieldname)
              if (node) fielddesc = node.innerHTML
              this.message += '\n' + fielddesc + ': '
            }
            if (typeof err.body[fieldname] === 'string')
              this.message += err.body[fieldname] + '\n'
            else {
              for (var msg in err.body[fieldname])
                this.message += err.body[fieldname][msg] + '\n'
            }
          }
        }
      }
      if (!this.message) this.message += err
    },
  },
})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
